import { render, staticRenderFns } from "./send_address.vue?vue&type=template&id=4e5b2004&scoped=true"
import script from "./send_address.vue?vue&type=script&lang=js"
export * from "./send_address.vue?vue&type=script&lang=js"
import style0 from "./send_address.vue?vue&type=style&index=0&id=4e5b2004&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5b2004",
  null
  
)

export default component.exports